export default "__VITE_ASSET__8W9MVOS4__"